import { Component, ElementRef, ViewChild } from "@angular/core";
import { QuoteService } from "../../services/quote.service";
import { NotificationsService } from "angular2-notifications";
import { AuthService } from "../../services/auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IQuotePayload } from "../../model/auth.model";
import { noWhitespaceValidator } from "../contactus/contact-us/contact-us.component";
import { SessionApi } from "../../api/session.api";
import { Router } from "@angular/router";

@Component({
  selector: "app-quote-request",
  templateUrl: "./quote-request.component.html",
  styleUrls: ["./quote-request.component.sass"],
})
export class QuoteRequestComponent {
  quoteForm!: FormGroup;
  quoteProducts$ = this.quoteService.quote$;
  @ViewChild("companyInfoSection") companyInfoSection!: ElementRef;

  constructor(
    private quoteService: QuoteService,
    private notifications: NotificationsService,
    private authService: AuthService,
    private fb: FormBuilder,
    private session: SessionApi,
    private router: Router,
  ) {
    this.quoteForm = this.fb.group({
      firstName: ["", [Validators.required, noWhitespaceValidator]],
      lastName: ["", [Validators.required, noWhitespaceValidator]],
      companyName: ["", [Validators.required, noWhitespaceValidator]],
      phone: ["", [Validators.required, noWhitespaceValidator]],
      email: ["", [Validators.required, Validators.email]],
      employees: ["", [Validators.required, noWhitespaceValidator]],
      location: ["", []],
      requirement: [""],
      productNames: [[], [Validators.required]],
    });

    session.$userData.subscribe((userData) => {
      if (userData) {
        this.router.navigate(["/home"]);
      }
    });
  }

  getProductNames(): string[] {
    return this.quoteService.getAll().map((p) => p.name);
  }

  removeToQuote(productId?: number) {
    if (!productId) {
      return;
    }
    this.quoteService.remove(productId);
  }

  submitQuote() {
    const productNames = this.getProductNames();

    if (!productNames.length) {
      this.notifications.warn(
        "Request Quote",
        "Please select products for quote.",
      );
      return;
    }

    this.quoteForm.patchValue({
      productNames,
    });

    if (this.quoteForm.invalid) {
      this.quoteForm.markAllAsTouched();
      return;
    }

    const body: IQuotePayload = {
      companyName: this.quoteForm.value.companyName,
      email: this.quoteForm.value.email,
      employees: this.quoteForm.value.employees.toString(),
      location: this.quoteForm.value.location,
      productNames: this.quoteForm.value.productNames,
      firstName: this.quoteForm.value.firstName,
      lastName: this.quoteForm.value.lastName,
      phone: this.quoteForm.value.phone.toString(),
      requirement: this.quoteForm.value.requirement,
    };

    this.authService.getQuote(body).subscribe(() => {
      this.quoteService.emptyProducts();
      this.quoteForm.reset();
    });
  }

  action(type: "link" | "scroll") {
    switch (type) {
      case "link":
        this.router.navigate(["/products"]);
        break;
      case "scroll":
        this.scrollToCompanyInfo();
        break;
      default:
        break;
    }
  }

  scrollToCompanyInfo() {
    setTimeout(() => {
      this.companyInfoSection.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
}
